module.exports = __webpack_public_path__ + "img/shopee.90a9a6ae.png";